import { createColumnHelper } from "@tanstack/react-table";
import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import { dateFormatter } from "../../../utils/dateFormatter";
import { StatusPill } from "../../order/orderTable/orderTableColumnsConfig";
const columnHelper = createColumnHelper();

export const refundTableColumnsConfig = (handleNavigateToDetail) => [
  columnHelper.accessor("id", {
    header: "ID",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("order_id", {
    header: "Order Id",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("delivered_on", {
    header: "Delivered On",
    cell: (info) => dateFormatter(info.getValue()),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("postal_code", {
    header: "PinCode",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),

  columnHelper.accessor("price", {
    header: "Total Amount",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: ({ getValue }) => {
      const status = getValue()?.toLowerCase();

      const configMap = {
        "refund requested": {
          label: "Refund Requested",
          bg: "#FFF4E5",
          color: "#FF9500",
          Icon: ClockIcon,
        },
        "refund in process": {
          label: "Refund In Process",
          bg: "#E6F0FF",
          color: "#1E56D9",
          Icon: ClockIcon,
        },
        "refund rejected": {
          label: "Refund Rejected",
          bg: "#FDECEA",
          color: "#D92D20",
          Icon: XCircleIcon,
        },
        refunded: {
          label: "Refunded",
          bg: "#E6F7EF",
          color: "#00A167",
          Icon: CheckCircleIcon,
        },
        unknown: {
          label: "Unknown",
          bg: "#FFF4E5", // light amber/orange background for caution
          color: "#FF9500", // amber/orange text to indicate attention
          Icon: ClockIcon, // clock icon to indicate pending/unknown state
        },
      };

      const config = configMap[status];

      if (!config) return "-";

      return <StatusPill {...config} />;
    },
  }),

  columnHelper.display({
    id: "actions",
    header: <div style={{ textAlign: "center" }}>Action</div>,
    cell: (props) => (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          style={actionBtnStyle}
          onClick={() => handleNavigateToDetail(props.row.original.id)}
        >
          View Details
        </button>
      </div>
    ),
  }),
];

const actionBtnStyle = {
  padding: "6px 12px",
  background: "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)",
  color: "#FFFFFF",
  fontWeight: 500,
  fontSize: "13px",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  transition: "all 0.3s ease",
  boxShadow: "0 2px 6px rgba(47,53,103,0.3)",
};
